import initialState from './customerDetailInitialState';
import mutations from './customerDetailMutation';
import actions from './customerDetailAction';

const getters = {
  getDetailAlertLoading: (state) => state.alertLoading,
  getDetailCycleLoading: (state) => state.cycleLoading,
  getDetailTab: (state) => state.activeTab,
  getDetailCustomer: (state) => state.customer,
  getDetailDevices: (state) => state.devices,
  getDetailAlertTableData: (state) => state.alertTableData,
  getDetailAlertSort: (state) => state.alertSort,
  getDetailAlertFilter: (state) => state.alertFilter,
  getDetailCycleTableData: (state) => state.cycleTableData,
  getDetailCycleDetail: (state) => state.cycleDetail,
  getShowCycleDetailModal: (state) => state.showCycleDetailModal,
  getDetailCycleViewTab: (state) => state.cycleViewTab,
  getDetailCycleFilter: (state) => state.cycleFilter,
  getExportCSVRange: (state) => state.exportCSV,

  cdTableRecordCount: (state) => {
    const {
      cycleTableData,
      cdTableOptions: {
        itemsPerPage,
      },
    } = state;

    if (cycleTableData.length === 0) {
      return 0;
    }
    return Math.ceil(cycleTableData.length / itemsPerPage);
  },
  coTableRecordCount: (state) => {
    const {
      customerOrders,
      coTableOptions: { itemsPerPage },
    } = state;
    const tableData = customerOrders.filter((o) => o.orderLines && o.orderLines.length > 0);
    if (tableData.length === 0) {
      return 0;
    }
    return Math.ceil(tableData.length / itemsPerPage);
  },
  summaryGraph: (state) => {
    const {
      dailyStats,
    } = state;

    const dateList = [];
    const runtimeList = [];
    const minTempList = [];
    const maxTempList = [];
    const coolDeltaTList = [];
    const heatDeltaTList = [];
    const filterLifeList = [];

    dailyStats.forEach((stat) => {
      const {
        localDate,
        adjustedRuntime,
        maxTempAPI,
        minTempAPI,
        deltaT,
        filterLife,
      } = stat;
      dateList.push(localDate);
      if (adjustedRuntime) {
        const {
          Heat,
          Fan,
          Cool,
        } = adjustedRuntime;
        let total = 0;
        if (Heat) {
          total = Heat;
        }
        if (Fan) {
          total += Fan;
        }
        if (Cool) {
          total += Cool;
        }
        runtimeList.push(Math.round(total / 3600));
      } else {
        runtimeList.push(0);
      }

      if (maxTempAPI) {
        maxTempList.push(maxTempAPI);
      } else {
        maxTempList.push(0);
      }

      if (minTempAPI) {
        minTempList.push(minTempAPI);
      } else {
        minTempList.push(0);
      }

      if (deltaT) {
        const {
          cool,
          heat,
        } = deltaT;
        if (cool) {
          coolDeltaTList.push(cool);
        } else {
          coolDeltaTList.push(0);
        }

        if (heat) {
          heatDeltaTList.push(heat);
        } else {
          heatDeltaTList.push(0);
        }
      } else {
        coolDeltaTList.push(0);
        heatDeltaTList.push(0);
      }
      if (filterLife) {
        const values = Object.values(filterLife);
        const life = values[0];
        filterLifeList.push(Math.round(life * 100));
      }
    });

    return {
      dateList,
      runtimeList,
      maxTempList,
      minTempList,
      coolDeltaTList,
      heatDeltaTList,
      filterLifeList,
    };
  },
};

const customerDetailModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default customerDetailModule;
